/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkRelatedIdentifierDTO
 */
export interface WorkRelatedIdentifierDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkRelatedIdentifierDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkRelatedIdentifierDTO
     */
    relatedIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkRelatedIdentifierDTO
     */
    relationType?: string;
}

/**
 * Check if a given object implements the WorkRelatedIdentifierDTO interface.
 */
export function instanceOfWorkRelatedIdentifierDTO(value: object): value is WorkRelatedIdentifierDTO {
    return true;
}

export function WorkRelatedIdentifierDTOFromJSON(json: any): WorkRelatedIdentifierDTO {
    return WorkRelatedIdentifierDTOFromJSONTyped(json, false);
}

export function WorkRelatedIdentifierDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkRelatedIdentifierDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'relatedIdentifier': json['relatedIdentifier'] == null ? undefined : json['relatedIdentifier'],
                  'relationType': json['relationType'] == null ? undefined : json['relationType'],
    };
}

export function WorkRelatedIdentifierDTOToJSON(json: any): WorkRelatedIdentifierDTO {
    return WorkRelatedIdentifierDTOToJSONTyped(json, false);
}

export function WorkRelatedIdentifierDTOToJSONTyped(value?: WorkRelatedIdentifierDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'relatedIdentifier': value['relatedIdentifier'],
        'relationType': value['relationType'],
    };
}


